// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrivacyPolicy_entry-img__m6oeb{
    position: absolute;
    width: 100vw;
    height: 60vw;
    margin-left: 0;
    margin-top: -13vw;
    z-index: -1;
}

.PrivacyPolicy_policy-container__oaoZv{
    width: 85vw;
    margin-left: 7.5vw;
    /* border: 1px solid black; */
    height: auto;
    padding-bottom: 5vw;
}

.PrivacyPolicy_policy-main-heading__uijs5{
    font-size: 4vw;
    font-family: dm-sans-medium;
    text-align: center;
    margin-top: -1vw;
    letter-spacing: -3px;
}

.PrivacyPolicy_policy-heading__Gr0h3{
    font-size: 3vw;
    text-align: center;
    margin-top: 1.5vw;
}

.PrivacyPolicy_point-heading__r\\+VjN{
    font-size: 2.3vw;
    font-weight: 500;
    margin-bottom: 0.5vw;
}

.PrivacyPolicy_point-desc__isa48{
    font-size: 1.5vw;
    font-weight: 300;
    line-height: 2.5vw;
    text-align: justify;
    margin-top: 0;
}

@media(max-width: 768px){

    .PrivacyPolicy_entry-img__m6oeb{
        margin-top: -22vh;
        height: 100vw;
    }
    
    .PrivacyPolicy_policy-container__oaoZv{
        width: 90vw;
        margin-left: 5vw;
        border: 1px solid black;
        height: auto;
        box-sizing: border-box;
        padding-bottom: 5vw;
        padding-left: 5vw;
        padding-right: 5vw;
        border-radius: 5vw;
        margin-bottom: 5vw;
        margin-top: 5vw;
    }

    .PrivacyPolicy_policy-main-heading__uijs5{
        font-size: 7vw;
        text-align: center;
        margin-top: 3vw;
        margin-bottom: 3vw;
    }
    
    .PrivacyPolicy_policy-heading__Gr0h3{
        font-size: 6vw;
        text-align: center;
        margin-top: 3vw;
        margin-bottom: 3vw;
    }
    
    .PrivacyPolicy_point-heading__r\\+VjN{
        font-size: 4vw;
        font-weight: 500;
        margin-bottom: 1vw;
    }
    
    .PrivacyPolicy_point-desc__isa48{
        font-size: 3vw;
        font-weight: 300;
        line-height: 3.5vw;
        text-align: justify;
        margin-top: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/FooterPages/PrivacyPolicy/PrivacyPolicy.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;;IAEI;QACI,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,uBAAuB;QACvB,YAAY;QACZ,sBAAsB;QACtB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB,kBAAkB;QAClB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,aAAa;IACjB;AACJ","sourcesContent":[".entry-img{\n    position: absolute;\n    width: 100vw;\n    height: 60vw;\n    margin-left: 0;\n    margin-top: -13vw;\n    z-index: -1;\n}\n\n.policy-container{\n    width: 85vw;\n    margin-left: 7.5vw;\n    /* border: 1px solid black; */\n    height: auto;\n    padding-bottom: 5vw;\n}\n\n.policy-main-heading{\n    font-size: 4vw;\n    font-family: dm-sans-medium;\n    text-align: center;\n    margin-top: -1vw;\n    letter-spacing: -3px;\n}\n\n.policy-heading{\n    font-size: 3vw;\n    text-align: center;\n    margin-top: 1.5vw;\n}\n\n.point-heading{\n    font-size: 2.3vw;\n    font-weight: 500;\n    margin-bottom: 0.5vw;\n}\n\n.point-desc{\n    font-size: 1.5vw;\n    font-weight: 300;\n    line-height: 2.5vw;\n    text-align: justify;\n    margin-top: 0;\n}\n\n@media(max-width: 768px){\n\n    .entry-img{\n        margin-top: -22vh;\n        height: 100vw;\n    }\n    \n    .policy-container{\n        width: 90vw;\n        margin-left: 5vw;\n        border: 1px solid black;\n        height: auto;\n        box-sizing: border-box;\n        padding-bottom: 5vw;\n        padding-left: 5vw;\n        padding-right: 5vw;\n        border-radius: 5vw;\n        margin-bottom: 5vw;\n        margin-top: 5vw;\n    }\n\n    .policy-main-heading{\n        font-size: 7vw;\n        text-align: center;\n        margin-top: 3vw;\n        margin-bottom: 3vw;\n    }\n    \n    .policy-heading{\n        font-size: 6vw;\n        text-align: center;\n        margin-top: 3vw;\n        margin-bottom: 3vw;\n    }\n    \n    .point-heading{\n        font-size: 4vw;\n        font-weight: 500;\n        margin-bottom: 1vw;\n    }\n    \n    .point-desc{\n        font-size: 3vw;\n        font-weight: 300;\n        line-height: 3.5vw;\n        text-align: justify;\n        margin-top: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"entry-img": `PrivacyPolicy_entry-img__m6oeb`,
	"policy-container": `PrivacyPolicy_policy-container__oaoZv`,
	"policy-main-heading": `PrivacyPolicy_policy-main-heading__uijs5`,
	"policy-heading": `PrivacyPolicy_policy-heading__Gr0h3`,
	"point-heading": `PrivacyPolicy_point-heading__r+VjN`,
	"point-desc": `PrivacyPolicy_point-desc__isa48`
};
export default ___CSS_LOADER_EXPORT___;
